"use strict";
// SPDX-License-Identifier: Apache-2.0
/* eslint-disable simple-import-sort/imports */
/* eslint-disable @typescript-eslint/ban-types */
/* eslint-disable @typescript-eslint/no-explicit-any */
Object.defineProperty(exports, "__esModule", { value: true });
exports.SAPPHIRE_WRAPPED_VIEM_SERIALIZER = exports.SAPPHIRE_WRAPPED_VIEM_TRANSPORT = exports.sapphireLocalnet = void 0;
exports.sapphireHttpTransport = sapphireHttpTransport;
exports.createSapphireSerializer = createSapphireSerializer;
exports.wrapWalletClient = wrapWalletClient;
const sapphire_paratime_1 = require("@oasisprotocol/sapphire-paratime");
const viem_1 = require("viem");
/**
 * sapphire-localnet chain, a local chain for local people
 */
exports.sapphireLocalnet = (0, viem_1.defineChain)({
    id: sapphire_paratime_1.NETWORKS.localnet.chainId,
    name: 'Oasis Sapphire Localnet',
    network: 'sapphire-localnet',
    nativeCurrency: { name: 'Sapphire Local Rose', symbol: 'TEST', decimals: 18 },
    rpcUrls: {
        default: {
            http: [sapphire_paratime_1.NETWORKS.localnet.defaultGateway],
            //webSocket: ["ws://localhost:8546/ws"],
        },
    },
    testnet: true,
});
// Hidden property used to detect if transport is Sapphire-wrapped
exports.SAPPHIRE_WRAPPED_VIEM_TRANSPORT = Symbol('#SAPPHIRE_WRAPPED_VIEM_TRANSPORT');
/**
 * Provide a Sapphire encrypted RPC transport for Wagmi or Viem.
 *
 * Example:
 * ```
 * import { createConfig } from 'viem';
 * import { sapphireHttpTransport } from '@oasisprotocol/sapphire-viem-v2';
 *
 * export const config = createConfig({
 *   transports: {
 *     [sapphireTestnet.id]: sapphireHttpTransport()
 *   },
 *   ...
 * });
 * ```
 *
 * Results for every instance of sapphireHttpTransport() are cached to prevent
 * the wrapper from being instantiated multiple times.
 *
 * @returns Same as http()
 */
function sapphireHttpTransport(argUrl) {
    const cachedProviders = {};
    return (params => {
        if (!params.chain) {
            throw new Error('sapphireTransport() not possible with no params.chain!');
        }
        const url = argUrl ?? params.chain.rpcUrls.default.http[0];
        if (!(url in cachedProviders)) {
            const x = (0, sapphire_paratime_1.wrapEthereumProvider)((0, viem_1.http)(url)(params));
            Reflect.set(x, exports.SAPPHIRE_WRAPPED_VIEM_TRANSPORT, true);
            cachedProviders[url] = x;
        }
        return cachedProviders[url];
    });
}
/**
 * Creates a Viem transaction serializer which encrypts transactions prior to
 * them being signed. This is compatible with both local wallet clients and
 * injected wallets.
 *
 * Example
 * ```
 * import { defineChain } from 'viem';
 * import { createSapphireSerializer } from '@oasisprotocol/sapphire-viem-v2';
 *
 * defineChain({
 *   serializers: {
 *     transaction: createSapphireSerializer(publicClient)
 *   },
 *   ...
 * });
 * ```
 *
 * @param client Provides upstream access to Sapphire JSON-RPC via `.request`
 * @param originalSerializer Optional serializer to wrap, otherwise will use default
 * @returns Sapphire wrapped transaction encryption serializer
 */
async function createSapphireSerializer(client, originalSerializer) {
    // Don't double-wrap serializer
    if (originalSerializer && Reflect.has(originalSerializer, exports.SAPPHIRE_WRAPPED_VIEM_SERIALIZER)) {
        return originalSerializer;
    }
    // As the serialized is synchronous, fetching keys while running
    const fetcher = new sapphire_paratime_1.KeyFetcher();
    const provider = client;
    await fetcher.fetch(provider);
    const timeout = setTimeout(async () => {
        await fetcher.fetch(provider);
    }, fetcher.timeoutMilliseconds);
    // MOOJO fix
    if (typeof timeout?.unref === 'function') {
        timeout.unref();
    }
    const wrappedSerializer = ((tx, sig) => {
        if (!sig) {
            const cipher = fetcher.cipherSync();
            const encryptedData = cipher.encryptCall(tx.data);
            tx.data = encryptedData;
        }
        if (originalSerializer) {
            return originalSerializer(tx, sig);
        }
        return (0, viem_1.serializeTransaction)(tx, sig);
    });
    Reflect.set(wrappedSerializer, exports.SAPPHIRE_WRAPPED_VIEM_SERIALIZER, true);
    return wrappedSerializer;
}
// Hidden property to test if serializer is Sapphire-wrapped
exports.SAPPHIRE_WRAPPED_VIEM_SERIALIZER = Symbol('#SAPPHIRE_WRAPPED_VIEM_SERIALIZER');
/**
 * Add the Sapphire transaction encryption wrapper to a wallet client
 *
 * Example:
 * ```
 * walletClient = await wrapWalletClient(createWalletClient({
 *   account,
 *   chain: sapphireLocalnet,
 *   transport: sapphireTransport()
 * }));
 * ```
 *
 * @param client Wagmi wallet client
 * @returns wrapped wallet client
 */
async function wrapWalletClient(client) {
    if (!client.chain) {
        throw new Error('No chain defined in client');
    }
    const originalSerializer = client.chain?.serializers?.transaction;
    // Override any existing transaction serializer, or create a new one
    // With one that auto-encrypts transactions before they're signed
    if (!originalSerializer || !Reflect.get(originalSerializer, exports.SAPPHIRE_WRAPPED_VIEM_SERIALIZER)) {
        if (!client.chain.serializers) {
            client.chain.serializers = {};
        }
        client.chain.serializers.transaction = await createSapphireSerializer(client, originalSerializer);
    }
    return client;
}
//# sourceMappingURL=data:application/json;base64,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